import {District} from '../address/district';

export class InterestDistrict {
  interestDistrictId: number;
  buyerId: number;
  districtId: number;
  district: District;
  status: string;
}
